module.exports = "https://cdn.realtymogul.com/static/media/mogulreiti.41ec9511.m4v";